import React, { useState, useEffect } from 'react';
import { Card, Switch, Typography, Divider, Select, Button, message, Spin, List } from 'antd';
import { getNavigationCategory } from '../../Layout/utils';
import { ROLE } from '../../constant/role';
import { getRequest, postRequest } from 'api';
import { SaveOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

const MenuConfig = () => {
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [selectedRole, setSelectedRole] = useState<string>(ROLE.ACCOUNTANT);
    const [categories, setCategories] = useState<any[]>([]);
    
    // Lưu các path đang BỊ TẮT (disabled)
    const [disabledPaths, setDisabledPaths] = useState<string[]>([]);
    const [fullConfig, setFullConfig] = useState<any>({});

    useEffect(() => {
        const fetchConfig = async () => {
            setLoading(true);
            const schoolId = localStorage.getItem('schoolId') || 1;
            
            try {
                const res = await getRequest(`/cms/menu-config?schoolId=${schoolId}`);
                if (res?.info) {
                    const configStr = res.info;
                    try {
                        const parsed = JSON.parse(configStr);
                        setFullConfig(parsed);
                        setDisabledPaths(parsed[selectedRole] || []);
                    } catch (e) {
                        setFullConfig({});
                        setDisabledPaths([]);
                    }
                } else {
                    setFullConfig({});
                    setDisabledPaths([]);
                }
            } catch (error) {
                message.error('Lỗi khi tải cấu hình Menu');
            }
            
            // Lấy tất cả menu của Role hiện tại (với mảng disabled rỗng để hiện tất cả)
            const allCategories = getNavigationCategory(selectedRole, []);
            setCategories(allCategories);
            setLoading(false);
        };

        fetchConfig();
    }, [selectedRole]);

    const handleToggle = (path: string, checked: boolean) => {
        setDisabledPaths(prev => {
            if (checked) {
                // Nếu checked (Bật) => Xóa khỏi danh sách disabled
                return prev.filter(p => p !== path);
            } else {
                // Nếu unchecked (Tắt) => Thêm vào danh sách disabled
                if (!prev.includes(path)) {
                    return [...prev, path];
                }
                return prev;
            }
        });
    };

    const handleSave = async () => {
        setSaving(true);
        const schoolId = localStorage.getItem('schoolId') || 1;

        try {
            const newConfig = {
                ...fullConfig,
                [selectedRole]: disabledPaths
            };

            await postRequest(`/cms/menu-config?schoolId=${schoolId}`, {
                menuConfig: JSON.stringify(newConfig)
            });

            setFullConfig(newConfig);
            message.success('Đã lưu cấu hình Menu thành công!');
        } catch (error) {
            message.error('Lưu cấu hình thất bại!');
        }
        setSaving(false);
    };

    return (
        <Card title={<div style={{ textAlign: 'left' }}>Cấu hình hiển thị Menu</div>}>
            <div style={{ marginBottom: 20 }}>
                <Text strong style={{ marginRight: 10 }}>Chọn vai trò (Role):</Text>
                <Select 
                    value={selectedRole} 
                    style={{ width: 200 }} 
                    onChange={setSelectedRole}
                >
                    <Option value={ROLE.ACCOUNTANT}>Kế toán</Option>
                    <Option value={ROLE.TEACHER}>Giáo viên</Option>
                </Select>
            </div>

            <Spin spinning={loading}>
                {categories.map((category) => (
                    <div key={category.id} style={{ marginBottom: 30 }}>
                        <Title level={5} style={{ color: '#1890ff', textAlign: 'left', margin: 0 }}>{category.id}</Title>
                        <Divider style={{ margin: '10px 0' }} />
                        <List
                            dataSource={category.children}
                            renderItem={(child: any) => (
                                <List.Item
                                    actions={[
                                        <Switch 
                                            checked={!disabledPaths.includes(child.path)} 
                                            onChange={(checked) => handleToggle(child.path, checked)} 
                                            checkedChildren="Hiện" 
                                            unCheckedChildren="Ẩn"
                                        />
                                    ]}
                                    style={{ borderBottom: 'none', padding: '10px 0', maxWidth: '500px' }}
                                >
                                    <div style={{ textAlign: 'left' }}>
                                        <Text>{child.id}</Text>
                                    </div>
                                </List.Item>
                            )}
                        />
                    </div>
                ))}
            </Spin>

            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                    type="primary" 
                    size="large"
                    icon={<SaveOutlined />} 
                    onClick={handleSave}
                    loading={saving}
                >
                    Lưu cấu hình
                </Button>
            </div>
        </Card>
    );
};

export default MenuConfig;
